import { Loader, LoaderOptions } from 'google-maps';
import { magnificPopup } from '../libs/magnific';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'jquery-ui/ui/widgets/slider';
import 'select2'; // Import Select2

const PRODUCT_LIST = [
  'XO 0094E',
  'XO 0234E',
  'XO 0315E',
  'XO 0554E',
  'XO 0602E',
  'XO 0731E',
  'XO 0993E',
  'XO 1095E',
  'XO 1225E',
  'XO 1372E',
  'XO 1404E',
  'XO 1545E',
  'XO 1632E',
  'XO 1761E',
  'XO 1822E',
  'XO 1971E',
  'XO 2075E',
  'XO 2181E',
  'XO 2282E',
  'XO 2305E',
  'XO 2444E',
  'XO 2625E',
  'XO 2735E',
  'XO 2832E',
  'XO 2865E',
  'XO 2963E',
  'XO 2985E',
  'XO 3014E',
  'XO 3105E',
  'XO 3224E',
  'XO 3375E',
  'XO 3483E',
  'XO 3555E',
  'XO 3655E',
  'XO 3705E',
  'XO 3752E',
  'XO 3795E',
  'XO 3855E',
  'XO 3922E',
  'XO 4132E',
  'XO 4255E',
  'XO 4364E',
  'XO 4405E',
  'XO 4522E',
  'XO 4653E',
  'XO 4772E',
  'XO 4894E'
];

document.addEventListener('DOMContentLoaded', () => {
  const customMapStyle = [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#e9f5db'
        }
      ]
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#523735'
        }
      ]
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#f5f1e6'
        }
      ]
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#c9b2a6'
        }
      ]
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#dcd2be'
        }
      ]
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#ae9e90'
        }
      ]
    },
    {
      featureType: 'administrative.neighborhood',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'landscape.natural',
      elementType: 'geometry',
      stylers: [
        {
          color: '#d9e9c7'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c5e1a5'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#a5d6a7'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        {
          color: '#f5f1e6'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#fdfcf8'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#f8c967'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#e9bc62'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#806b63'
        }
      ]
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry',
      stylers: [
        {
          color: '#dfd2ae'
        }
      ]
    },
    {
      featureType: 'transit.line',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8f7d77'
        }
      ]
    },
    {
      featureType: 'transit.line',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ebe3cd'
        }
      ]
    },
    {
      featureType: 'transit.station',
      elementType: 'geometry',
      stylers: [
        {
          color: '#dfd2ae'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#aee0f4'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }
  ];

  let currentRmRange = [0, 5]; // Initialize with default values

  function initRelativeMaturitySlider(minRM, maxRM, filterCallback) {
    $('#slider-range').slider({
      range: true,
      min: 0,
      max: 5,
      values: [0, 5],
      step: 0.2,
      slide: (event, ui) => {
        currentRmRange = ui.values;
        filterCallback(currentRmRange);

        $('#slider-range .ui-slider-handle:first').text(`${ui.values[0]}`);
        $('#slider-range .ui-slider-handle:last').text(`${ui.values[1]}`);
      },
      create: (event, ui) => {
        $('#slider-range .ui-slider-handle:first').text(`${minRM}`);
        $('#slider-range .ui-slider-handle:last').text(`${maxRM}`);
      }
    });
  }

  const mapContainers = document.querySelectorAll('.gmap');

  if (mapContainers) {
    const options = {
      libraries: ['places']
    };
    const loader = new Loader('AIzaSyAjF9QzKVHmYBAyOzAN3-MntvN4_mOCysk', options);

    loader.load().then(async google => {
      const mapElement = document.querySelector('.gmap');
      const map = new google.maps.Map(mapElement, {
        zoom: 6,
        center: { lat: 39.8282, lng: -98.5795 },
        // mapId: 'a5433fa8ad02432',
        // mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: customMapStyle,
        mapTypeControlOptions: {
          mapTypeIds: []
        },
        maxZoom: 11
      });

      const yearDropdown = document.getElementById('year-dropdown');
      const varietyDropdown = document.getElementById('variety-dropdown');
      const cropsDropdown = document.getElementById('crops-dropdown');
      const zipInput = document.getElementById('zip-input');
      const resetFilterButton = document.getElementById('reset-filters');

      // Initialize Select2 on the dropdowns
      $(yearDropdown)
        .select2({
          placeholder: 'Select a year',
          allowClear: true,
          minimumResultsForSearch: -1
        })
        .on('change', function() {
          filterMarkers(yearDropdown, varietyDropdown, markers, data.features, currentRmRange);
        });

      $(varietyDropdown)
        .select2({
          placeholder: 'Select a product',
          allowClear: true
        })
        .on('change', () => {
          filterMarkers(yearDropdown, varietyDropdown, markers, data.features, currentRmRange);
        });

      $(cropsDropdown)
        .select2({
          placeholder: 'Select a product',
          allowClear: false,
          minimumResultsForSearch: 'Infinity'
        })
        .on('change', () => {
          const selectedCrop = $(cropsDropdown)
            .find(':selected')
            .val();
          if (selectedCrop !== 'all-crops') {
            window.open(selectedCrop, '_blank');
          }
        });

      $(resetFilterButton).on('click', () => {
        $(yearDropdown)
          .val('All Years')
          .trigger('change');

        $(varietyDropdown)
          .val('All Products')
          .trigger('change');

        $(cropsDropdown)
          .val('all-crops')
          .trigger('change');

        $('#slider-range').slider('values', [0, 5]);
        $('#slider-range .ui-slider-handle:first').text('0');
        $('#slider-range .ui-slider-handle:last').text('5');
        $('#slider-range')
          .slider('option', 'slide')
          .call($('#slider-range'), null, {
            values: $('#slider-range').slider('values')
          });
      });

      // Initialize relative maturity slider after Select2 is initialized
      initRelativeMaturitySlider(0, 5, rmRange => {
        filterMarkers(yearDropdown, varietyDropdown, markers, data.features, rmRange);
      });

      const autocomplete = new google.maps.places.Autocomplete(zipInput, {
        types: ['(regions)'],
        componentRestrictions: { country: 'us' }
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const location = place.geometry.location;
          map.setCenter(location);
          map.fitBounds(autocomplete.getPlace().geometry.viewport);
        }
      });

      navigator.geolocation.getCurrentPosition(position => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        map.setCenter(userLocation);
      });
      const response = await fetch('https://basf-mw.in10t.solutions/fields?crop=soybean&company=seedx&map=true');
      const data = await response.json();
      if (!data.features || !Array.isArray(data.features)) {
        console.error('No features found in API response:', data);
        return;
      }

      const markers = [];
      let currentPopup = null;

      data.features.forEach(feature => {
        if (feature.geometry && Array.isArray(feature.geometry.coordinates)) {
          const [lat, lng] = feature.geometry.coordinates;
          const customMarkerIcon = {
            url: '../assets/images/marker.png', // Replace with the path to your custom icon image
            scaledSize: new google.maps.Size(30, 30),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(30, 30)
          };
          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            icon: customMarkerIcon,
            map: map
          });
          const trialId = feature.properties.trial_id;
          const infoYear = feature.properties.year;
          const crop = feature.properties.crop;
          const brands = feature.properties.brand.join(', ');
          const infoWindow = new google.maps.InfoWindow({
            content: `<div> 
                        <p>
                          <strong>Year:</strong> ${feature.properties.year}<br>
                          <strong>City:</strong> ${feature.properties.city}<br>
                          <strong>State:</strong> ${feature.properties.state}<br>
                          <a target="_blank" class="map-popup-button" href="trial-details.html?year=${infoYear}&crop=${crop}&company=seedx&trial=${trialId}">See Trial Data ></a>
                        </p>
                      </div>`
          });

          marker.addListener('click', () => {
            if (currentPopup) {
              currentPopup.close();
            }
            infoWindow.open(map, marker);
            currentPopup = infoWindow;
          });

          markers.push(marker);
        }
      });

      const yearSet = new Set(['All Years']);

      data.features.forEach(feature => {
        yearSet.add(feature.properties.year);
      });

      addOptions(yearDropdown, Array.from(yearSet), 'All Years');

      addOptions(varietyDropdown, ['All Products', ...PRODUCT_LIST], 'All Products');

      filterMarkers(yearDropdown, varietyDropdown, markers, data.features, currentRmRange); // Display all markers by default
    });
  }

  function addOptions(selectElement, optionsArray, defaultValue) {
    selectElement.innerHTML = '';
    optionsArray
      .sort((a, b) => b - a) // Sort years in descending order
      .forEach(optionValue => {
        const optionElement = document.createElement('option');
        optionElement.value = optionValue;
        optionElement.textContent = optionValue;
        if (optionValue === defaultValue) {
          optionElement.selected = true;
        }
        selectElement.appendChild(optionElement);
      });
    $(selectElement).trigger('change'); // Trigger change event for Select2
  }

  function filterMarkers(yearDropdown, varietyDropdown, markers, features, rmRange) {
    let selectedYear = $(yearDropdown).select2('val');
    let selectedVarieties = $(varietyDropdown).select2('val');
    // Ensure selectedVarieties is an array
    if (!Array.isArray(selectedVarieties)) {
      selectedVarieties = selectedVarieties ? [selectedVarieties] : [];
    }

    const year = yearDropdown.value;

    // Check if rmRange is undefined before destructuring
    let minRM = 0,
      maxRM = 5;
    if (rmRange && Array.isArray(rmRange)) {
      [minRM, maxRM] = rmRange;
    }

    markers.forEach((marker, i) => {
      const feature = features[i];
      const featureYear = feature.properties.year.toString();
      const featureVarieties = feature.properties.variety.map(v => v.variety);

      // Check if all selected varieties are included in the feature varieties
      const allVarietiesMatch = selectedVarieties.every(selectedVariety => {
        const isMatch = featureVarieties.includes(selectedVariety);
        return isMatch;
      });

      const shouldDisplay =
        (year === 'All Years' || featureYear === year) &&
        (selectedVarieties.includes('All Products') || allVarietiesMatch) &&
        feature.properties.variety.some(v => parseFloat(v.rm) >= minRM && parseFloat(v.rm) <= maxRM);

      marker.setVisible(shouldDisplay);
    });
  }
});
